/**
 * getCookieValue
 * @param {string} key - The name of the cookie to find.
 * @returns {string|null} - The value of the cookie, or null if not found.
 */
export function GetTrackingId(key) {
	const val = localStorage.getItem(key);
	if (val) return val;

	// Construct a RegExp to locate `cookieName=...` in the document.cookie string
	const match = document.cookie.match(new RegExp('(^|;\\s*)' + key + '=([^;]*)'));
	// If found, decode and return; otherwise return null
	return match ? decodeURIComponent(match[2]) : null;
}
